// custom.js
(() => {
  var HelperApp = (() => {
    var getRandomInt = (min, max) => {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    return {
      getRandomInt: getRandomInt
    }
  })();


  var BDModalApp = (() => {
    var openModal = (modal) => {
      if (!modal) return;
      modal.classList.add('open');
    }
    var closeModal = (modal) => {
      if (!modal) return;
      modal.classList.remove('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-bd-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          openModal(document.querySelector(`[js-bd-modal="${element.getAttribute('js-bd-modal-trigger')}"]`));
        });
      });
      document.querySelectorAll('[js-bd-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          closeModal(element.closest('[js-bd-modal]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var ProtectionInfoModalApp = (() => {
    var closeModal = () => {
      var modal = document.querySelector('[data-protection-info-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
    }
    var openModal = () => {
      var modal = document.querySelector('[data-protection-info-modal]');
      if (!modal) return;
      modal.classList.add('is-open');
      updateFades();
    }
    var updateFades = () => {
      var scroller = document.querySelector('[data-protection-info-modal-scroll]');
      if (!scroller) return;
      var sheet = scroller.closest('.protection-info-modal__sheet');
      if (!sheet) return;
      sheet.classList.toggle('has-scroll-top', scroller.scrollTop > 1);
      sheet.classList.toggle('has-scroll-bottom', scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 1);
    }
    var initialize = () => {
      var scroller = document.querySelector('[data-protection-info-modal-scroll]');
      if (scroller) {
        scroller.addEventListener('scroll', updateFades, { passive: true });
        window.addEventListener('resize', updateFades);
      }
      document.querySelectorAll('[js-quick-cart-modal-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        });
      });
      document.querySelectorAll('[data-protection-info-modal-close]').forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        });
      });
      var modal = document.querySelector('[data-protection-info-modal]');
      if (modal) {
        // Keep Escape scoped to this modal so it never bubbles into the
        // quick cart drawer's own Escape-to-close handler.
        modal.addEventListener('keydown', (e) => {
          e.stopPropagation();
          if (e.keyCode === 27) closeModal();
        });
      }
    }
    return {
      init: initialize
    }
  })();

  var BDQuickCartTimerApp = (() => {
    const TIMER_DURATION = 5 * 60 * 1000; // minutes * 60 * 1000
    const STORAGE_KEY = '[BD] Quick cart timer expiry';
    const STORAGE_STARTED_KEY = '[BD] Quick cart timer started';

    // keep cleanup fns to avoid multiple ticking loops
    const cleanupByElement = new Map();
    // keep reference to current observer so we can disconnect it when cart updates (avoids duplicate countdowns after re-render)
    let currentObserver = null;

    function getTimerExpiry() {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? parseInt(stored, 10) : null;
    }

    function setTimerExpiry(timestamp) {
      localStorage.setItem(STORAGE_KEY, timestamp.toString());
    }

    function hasTimerStarted() {
      return localStorage.getItem(STORAGE_STARTED_KEY) === 'true';
    }

    function setTimerStarted() {
      localStorage.setItem(STORAGE_STARTED_KEY, 'true');
    }

    function resetStoredTimer() {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_STARTED_KEY);
    }

    function stopAllCountdowns() {
      cleanupByElement.forEach((cleanup) => {
        try { cleanup && cleanup(); } catch (e) {}
      });
      cleanupByElement.clear();
    }

    function startCountdown(container, minuteElement, secondElement) {
      const textElement = container.querySelector('[js-text]');
      const timerElement = container.querySelector('[js-timer]');
      if (!textElement || !timerElement) return () => {};

      let expiryTime = getTimerExpiry();
      const now = Date.now();

      if (!expiryTime || now >= expiryTime) {
        expiryTime = now + TIMER_DURATION;
        setTimerExpiry(expiryTime);
      }

      let timeoutId;

      function tick() {
        const now = Date.now();
        const remaining = Math.max(0, expiryTime - now);

        timerElement.classList.remove('d-none');

        const totalSeconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        minuteElement.textContent = String(minutes).padStart(2, '0');
        secondElement.textContent = String(seconds).padStart(2, '0');

        textElement.innerHTML = textElement.getAttribute('data-timer-text');

        if (remaining === 0) {
          setTimeout(() => {
            textElement.innerHTML = textElement.getAttribute('data-timer-end-text');
            timerElement.classList.add('d-none');
          }, 100);
          return;
        }

        // schedule next tick near next full second boundary
        const msToNextSecond = 1000 - (now % 1000);
        timeoutId = setTimeout(tick, msToNextSecond);
      }

      tick();

      // return cleanup
      return () => {
        if (timeoutId) clearTimeout(timeoutId);
      };
    }

    function runForAllTimers({ forceReset = false } = {}) {
      const timerElements = document.querySelectorAll('[js-quick-cart-timer]');

      // stop existing loops (important if cart rerenders or event fires often)
      stopAllCountdowns();

      if (timerElements.length === 0) {
        if (currentObserver) {
          currentObserver.disconnect();
          currentObserver = null;
        }
        return;
      }

      // disconnect previous observer so it never fires again (prevents 2 countdowns when cart re-renders after add)
      if (currentObserver) {
        currentObserver.disconnect();
        currentObserver = null;
      }

      if (forceReset) {
        resetStoredTimer();
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const timerElement = entry.target;
          const minuteElement = timerElement.querySelector('[js-minute-value]');
          const secondElement = timerElement.querySelector('[js-second-value]');
          if (!minuteElement || !secondElement) return;

          let expiryTime = getTimerExpiry();
          const now = Date.now();

          // on first run, or if expired, set a new expiry
          if (!hasTimerStarted() || !expiryTime || now >= expiryTime) {
            expiryTime = now + TIMER_DURATION;
            setTimerExpiry(expiryTime);
            setTimerStarted();
          }

          // start countdown + remember cleanup
          const cleanup = startCountdown(timerElement, minuteElement, secondElement);
          cleanupByElement.set(timerElement, cleanup);

          observer.unobserve(timerElement);
        });
      }, { threshold: 0.1 });

      currentObserver = observer;
      timerElements.forEach((el) => observer.observe(el));
    }

    function initialize() {
      // initial start on DOM ready
      runForAllTimers({ forceReset: false });

      // restart timer on cart updates (add/remove/change qty)
      document.addEventListener('cart:updated', function (evt) {
        console.log('Cart updated');
        console.log(evt.detail && evt.detail.cart);

        // restart from full duration whenever cart changes:
        runForAllTimers({ forceReset: true });
      });
    }

    return { init: initialize };
  })();

  var BDProductStockStatusWrapperApp = (() => {
    const STORAGE_KEY = '[BD] Product stock random percent';
    var saveDataToLocalStorage = (data, variant_id) => {
      let percent_storage_data_json = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!percent_storage_data_json) percent_storage_data_json = {};

      percent_storage_data_json[variant_id] = {};
      percent_storage_data_json[variant_id]['time'] = Date().toString();
      percent_storage_data_json[variant_id]['data'] = data;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(percent_storage_data_json));
    }
    var initEachContainer = (container) => {
      if (!container) return;
      const min_random_percent = isNaN(parseInt(container.getAttribute('data-min-percent-value'))) ? 0 : parseInt(container.getAttribute('data-min-percent-value'));
      const max_random_percent = isNaN(parseInt(container.getAttribute('data-max-percent-value'))) ? 100 : parseInt(container.getAttribute('data-max-percent-value')) ;
      let percent_value = HelperApp.getRandomInt(min_random_percent, max_random_percent);

      const variant_id = container.getAttribute('data-variant-id');
      let percent_storage_data_json = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!percent_storage_data_json || !percent_storage_data_json[variant_id] || !percent_storage_data_json[variant_id]['time'] || !percent_storage_data_json[variant_id]['data']) {
        saveDataToLocalStorage(percent_value, variant_id);
      } else {
        const saved_time = new Date(percent_storage_data_json[variant_id]['time']);
        const now = new Date();
        if (
          saved_time.getFullYear() === now.getFullYear() &&
          saved_time.getMonth() === now.getMonth() &&
          saved_time.getDate() === now.getDate() && 
          percent_storage_data_json[variant_id]['data'] >= min_random_percent &&
          percent_storage_data_json[variant_id]['data'] <= max_random_percent
        ) {
          percent_value = percent_storage_data_json[variant_id]['data'];
        } else {
          saveDataToLocalStorage(percent_value, variant_id);
        }
      }

      container.style.setProperty('--percent', `${percent_value}%`);

      const percentMessageElement = container.querySelector('[js-percent-message]');
      if (percentMessageElement && percentMessageElement.hasAttribute('data-template')) {
        percentMessageElement.innerHTML = String(percentMessageElement.getAttribute('data-template')).replace('((value))', `<span>${percent_value}%</span>`)
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-stock-status-wrapper]').forEach(container => {
        initEachContainer(container);
      });
      document.addEventListener('product:variant-change', (evt) => {
        document.querySelectorAll('[js-stock-status-wrapper]').forEach(element => {
          element.classList.add('d-none');
          if (String(element.getAttribute('data-variant-id')) === String(evt.detail.variant.id)) {
            element.classList.remove('d-none');
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var BDPDPUpsellProductApp = (() => {
    var atc = async (upsellWrapper) => {
      if (!upsellWrapper || upsellWrapper.classList.contains('loading')) return;

      upsellWrapper.classList.add('loading');

      let variant_id;
      if (upsellWrapper.querySelector('[js-upsell-variant-option].active')) {
        variant_id = upsellWrapper.querySelector('[js-upsell-variant-option].active').getAttribute('data-variant-id');
      } else if (upsellWrapper.querySelector('[data-default-variant-id]')) {
        variant_id = upsellWrapper.querySelector('[data-default-variant-id]').getAttribute('data-default-variant-id');
      }

      const data = await window.cart.addItemById(variant_id, 1);
      console.log('here is data', data);
      window.r$3("cart:open", null, {
        flash: item.variant_id
      });

      upsellWrapper.classList.remove('loading');
    }
    var showUpsellProductWrapper = (variant_id) => {
      if (variant_id === '' || !variant_id) return;
      document.querySelectorAll('[js-pdp-upsell-product]').forEach(element => {
        if (element.getAttribute('data-variant-id') === String(variant_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var selectUpsellVariant = (upsellWrapper, variant_id) => {
      if (!upsellWrapper || !variant_id || variant_id === '') return;
      upsellWrapper.querySelectorAll('[js-upsell-variant-option], [js-upsell-varaint-price-wrapper]').forEach(element => {
        if (element.getAttribute('data-variant-id') === String(variant_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var initialize = () => {
      document.addEventListener("product:variant-change", function (evt) {
        showUpsellProductWrapper(evt.detail.variant.id);
      });
      document.querySelectorAll('[js-pdp-upsell-product] [js-upsell-variant-option]').forEach(element => {
        element.addEventListener('click', () => {
          selectUpsellVariant(element.closest('[js-pdp-upsell-product]'), element.getAttribute('data-variant-id'));
        });
      });
      document.querySelectorAll('[js-pdp-upsell-product] [js-atc]').forEach(element => {
        element.addEventListener('click', () => {
          atc(element.closest('[js-pdp-upsell-product]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var BDCollectionBannerApp = (() => {
    var initialize = () => {
      document.querySelectorAll('.bd-collection-banner-section .highlight-card--view-more-wrapper .more-trigger').forEach(element => {
        element.addEventListener('click', () => {
          const viewLessContent = element.closest('.highlight-card--view-more-wrapper').querySelector('.content');
          const viewMoreContent = element.closest('.highlight-card--view-more-wrapper').querySelector('.more-trigger');
          if (viewLessContent && viewMoreContent) {
            viewLessContent.classList.remove('d-none');
            viewMoreContent.classList.add('d-none');
          }
        });
      });
      document.querySelectorAll('.bd-collection-banner-section .highlight-card--view-more-wrapper .content').forEach(element => {
        element.addEventListener('click', () => {
          const viewLessContent = element.closest('.highlight-card--view-more-wrapper').querySelector('.content');
          const viewMoreContent = element.closest('.highlight-card--view-more-wrapper').querySelector('.more-trigger');
          if (viewLessContent && viewMoreContent) {
            viewLessContent.classList.add('d-none');
            viewMoreContent.classList.remove('d-none');
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var BDTabContainerApp = (() => {
    var open = (container, data_symbol, data_index) => {
      if (!container || data_index === '') return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        if (element.getAttribute('data-symbol') == data_symbol) {
          element.classList.remove('active');
          if (element.getAttribute('data-index') === data_index) {
            element.classList.add('active');
          }
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab-container] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab-container]'), element.getAttribute('data-symbol'), element.getAttribute('data-index'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  let cartProtectionUpsellApp = (() => {
    // NN#31 A/B test: one upsell per variant is rendered, only one is visible
    let initialize = () => {
      document.querySelectorAll('.cart-protection-upsell').forEach(initUpsell);
    }

    let initUpsell = (upsell) => {
      var quickCart = upsell.closest('[data-quick-cart]');
      var allProtectionIds = ((quickCart && quickCart.dataset.protectionVariantIds) || '').split(',').filter(Boolean);
      var variantId = parseInt(upsell.dataset.variantId, 10);
      let protectionIconEle = upsell.querySelector(".cpu-icon");
      var toggleBtn = upsell.querySelector('.cpu-toggle-button');
      var subtotalEl = document.querySelector('[data-subtotal]');
      var neonaBadge = document.querySelector('.neona-shipping-badge');
      var checkoutBtnText = document.querySelector('.checkout-btn-text');
    
      var isProcessing = false;
    
      toggleBtn.addEventListener('click', function () {
        if (isProcessing) {
          console.log("Now, the cart is being processed");
          return;
        }
    
        var isActive = toggleBtn.classList.contains('is-active');
        isProcessing = true;
    
        // Optimistic UI update
        toggleBtn.classList.toggle('is-active');
        if (!isActive) {
          protectionIconEle.classList.add('is-active');
        } else {
          protectionIconEle.classList.remove('is-active');
        }
        if (neonaBadge) neonaBadge.classList.toggle('is-hidden');
        // if (checkoutBtnText) {
        //   checkoutBtnText.textContent = isActive
        //     ? checkoutBtnText.dataset.defaultText
        //     : checkoutBtnText.dataset.protectionText;
        // }
    
        var endpoint = isActive ? '/cart/update.js' : '/cart/add.js';
        var payload = isActive
          ? { updates: { [variantId]: 0 } }
          : { items: [{ id: variantId, quantity: 1 }] };
    
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart request failed: ' + res.status);
            return res.json();
          })
          .then(function () {
            // /cart/add.js returns added items, not the full cart
            // /cart/change.js returns the full cart but without consistent total format
            // Fetch cart separately to reliably get the updated total
            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          // .then(function (cart) {
          //   updateSubtotal(cart.total_price);
          // })
          .then(function (cart) {
            updateSubtotal(cart.total_price);

            // Trigger cart icon pulse animation
            if (window.r$3) window.r$3('cart:updated', { cart: cart });

            // Override count to exclude protection product
            var visibleCount = cart.items
              .filter(function(item) {
                return allProtectionIds.indexOf(String(item.variant_id)) === -1 && String(item.variant_id) !== String(variantId);
              })
              .reduce(function(sum, item) { return sum + item.quantity; }, 0);

            var countEl = document.querySelector('[data-js-cart-count]');
            if (countEl) countEl.textContent = visibleCount;
          })
          .catch(function () {
            // Revert optimistic UI on failure
            toggleBtn.classList.toggle('is-active');
            if (neonaBadge) neonaBadge.classList.toggle('is-hidden');
            if (checkoutBtnText) {
              checkoutBtnText.textContent = isActive
                ? checkoutBtnText.dataset.protectionText
                : checkoutBtnText.dataset.defaultText;
            }
          })
          .finally(function () {
            isProcessing = false;
          });
      });
    
      function updateSubtotal(totalPriceInCents) {
        if (!subtotalEl) return;
        var amount = totalPriceInCents / 100;
        subtotalEl.textContent = amount.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + '\u00a0€';
      }
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      BDModalApp.init();
      ProtectionInfoModalApp.init();
      BDQuickCartTimerApp.init();
      BDProductStockStatusWrapperApp.init();
      BDPDPUpsellProductApp.init();
      BDCollectionBannerApp.init();
      BDTabContainerApp.init();
      cartProtectionUpsellApp.init();
    }
    return {
      init: initialize
    }
  })();

 document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', (e) => {
      console.log("Here is the product card function.....23");
      const card = e.target.closest('.collection-product-card');
      if (!card) return;

      card.classList.toggle('expanded');
      card.classList.toggle('collapsed');
    });

    App.init();
      // for BD Feat - Product Grid Item Slider
  
      var isAutoAnimating = false; //  ADD THIS LINE (Flag to prevent scroll during auto-animation)
  
      document.querySelectorAll('.bd-main-collection-product-grid .product_item_image').forEach(function(el) {
        if(!el.classList.contains('swiper-initialized')) {
        new Swiper(el, {
          direction: 'horizontal',
          loop: true,
          effect: 'slide',
          initialSlide: parseInt(el.getAttribute("data-initialSlide")),
          on: {
            slideChangeTransitionEnd: function () {
              console.log(this, this.activeIndex, parseInt(el.getAttribute("data-initialSlide")), this.el.querySelector('[data-swiper-slide-index="'+this.activeIndex+'"]'));
              if (this.el.querySelector('.swiper-slide.swiper-slide-active').getAttribute('data-variants_media') != ' ' && this.el.querySelector('.swiper-slide.swiper-slide-active').getAttribute('data-variants_media') != null && this.el.querySelector('.swiper-slide.swiper-slide-active').getAttribute('data-variants_media') != undefined) {
                const variantButtons = this.el.closest('.product-item').querySelectorAll('.product-item__color-variant');
                variantButtons.forEach((button) => {
                  if (this.el.querySelector('.swiper-slide.swiper-slide-active').getAttribute('data-variants_media').indexOf(button.getAttribute("data-variant-id")) > -1) {
                    variantButtons.forEach(buttons => {
                      buttons.classList.remove('active');
                    });
                    button.classList.add('active');
                    if (!isAutoAnimating) { 
                      /* nn-fix: nur die Farbleiste horizontal scrollen, nie die Seite */ var nnRow = button.closest('.product-item__color-variants-inner'); if (nnRow) nnRow.scrollBy({ left: button.getBoundingClientRect().left - nnRow.getBoundingClientRect().left, behavior: 'smooth' });
                    } 
                  }
                });
              }
            },
          }
        });
        }
      });
  
      var once_time = 0;
  
      if (window.innerWidth <= 768 && document.querySelector('.product-item__inner') != null) {
  
        function isInViewport(el) {
          const rect = el.getBoundingClientRect();
          const elementHeight = rect.height;

          // How much of the element is visible vertically
          const visibleTop = Math.max(rect.top, 0);
          const visibleBottom = Math.min(rect.bottom, window.innerHeight);
          const visibleHeight = visibleBottom - visibleTop;

          // If visible portion >= 50% of element height
          return visibleHeight >= elementHeight * 0.5;
        }
  
        function checkVisibleElements() {
          if (isInViewport(document.querySelector('.product-item__inner')) && once_time == 0) {
            myFunction(document.querySelector('.product-item__inner'));
            once_time = 1;
          }
        }
  
        window.addEventListener('scroll', checkVisibleElements);
        window.addEventListener('resize', checkVisibleElements);
  
        function myFunction(el) {
          const swiperEl = el.querySelector('.product_item_image.swiper');
          if (swiperEl && swiperEl.swiper) {
            const swiper = swiperEl.swiper;
            isAutoAnimating = true;
            setTimeout(() => {
              const slideWidth = swiper.slides[0].offsetWidth;
              const offset = slideWidth * 0.3;   // move 30% of next slide

              swiper.setTransition(400);         // smooth animation
              swiper.setTranslate(-offset);      // apply partial shift
              setTimeout(() => {
                swiper.setTranslate(0);
              }, 500);

              swiper.updateProgress();
              swiper.updateActiveIndex();
              swiper.updateSlidesClasses();

              // Prevent further automatic animations
              isAutoAnimating = false;
            }, 300);
          }
        }
      }
  });

  
  // for BD Feat - Product Grid Item Slider End
  
  
window.addEventListener('scroll', function() {
  const filterBar = document.querySelector('.filter-bar__inner');
  const collectionContent = document.querySelector('.collection__content');
  const collectionSection = document.querySelector('.bd-main-collection-product-grid'); // The collection section
  
  if (!filterBar || !collectionContent || !collectionSection) return;

  const contentTop = collectionContent.getBoundingClientRect().top;
  const sectionBottom = collectionSection.getBoundingClientRect().bottom;
  
  // Show filter bar ONLY when:
  // 1. Scrolled past collection content (contentTop <= 0)
  // 2. Still inside collection section (sectionBottom > 100)
  if (contentTop <= 0 && sectionBottom > 100) {
    filterBar.classList.add('show');
  } else {
    filterBar.classList.remove('show');
  }

  // document.addEventListener('click', (e) => {
  //   const card = e.target.closest('.collection-product-card');
  //   if (!card) return;

  //   card.classList.toggle('expanded');
  //   card.classList.toggle('collapsed');
  // });
});
  
  
})();

document.addEventListener("click", function(e) {
  const customClearBtn = e.target.closest('button[data-button="clear-all_custom"]');
  if (!customClearBtn) return;

  const originalClearBtn = document.querySelector('button[data-button="clear-all"]');
  if (originalClearBtn) originalClearBtn.click();
});

var bdHideOptionsRulesCache = null;
var getBdHideOptionsRules = () => {
  if (bdHideOptionsRulesCache) return bdHideOptionsRulesCache;

  const rulesEl = document.querySelector('[data-bd-hide-options-rules]');
  if (!rulesEl) return null;

  let rawRules;
  try { rawRules = JSON.parse(rulesEl.textContent); } catch(e) { return null; }
  if (!rawRules || !rawRules.length) return null;

  const variantJsonEl = document.querySelector('[data-variant-json]');
  if (!variantJsonEl) return null;

  let allVariants;
  try { allVariants = JSON.parse(variantJsonEl.textContent); } catch(e) { return null; }

  const rules = rawRules.map(rule => {
    const hidePos = parseInt(rule.hide_option.replace('Option', ''));
    const triggerPos = rule.trigger_option ? parseInt(rule.trigger_option.replace('Option', '')) : null;

    const hideOptionWrapper = document.querySelector(
      `[data-product-variants] [data-product-option="${rule.hide_option}"]`
    );
    if (!hideOptionWrapper) return null;

    const hideButton = hideOptionWrapper.querySelector(
      `button[data-option-value="${rule.hide_value}"]`
    );
    if (!hideButton) return null;

    return { ...rule, hidePos, triggerPos, hideOptionWrapper, hideButton };
  }).filter(Boolean);

  if (!rules.length) return null;

  bdHideOptionsRulesCache = { rules, allVariants };
  return bdHideOptionsRulesCache;
};

var hideUnavailableVariantOptions = (current_variant_id) => {
  const cache = getBdHideOptionsRules();
  if (!cache) return;
  const { rules, allVariants } = cache;

  const currentVariant = allVariants.find(v => String(v.id) === String(current_variant_id));
  if (!currentVariant) return;

  rules.forEach(rule => {
    const { hidePos, triggerPos, hideOptionWrapper, hideButton } = rule;

    const shouldHide = (() => {
      // If a trigger is defined, the rule only applies when the current variant matches it
      if (rule.trigger_option && rule.trigger_value) {
        if (currentVariant['option' + triggerPos] !== rule.trigger_value) return false;
      }

      if (rule.always_hide === true || rule.always_hide === 'true') return true;

      // Find variants that match the current selection in all OTHER options,
      // combined with hide_value — to check if any such combination is available
      const matchingVariants = allVariants.filter(v => {
        for (let i = 1; i <= 3; i++) {
          if (i === hidePos) {
            if (v['option' + i] !== rule.hide_value) return false;
          } else if (currentVariant['option' + i]) {
            if (v['option' + i] !== currentVariant['option' + i]) return false;
          }
        }
        return true;
      });
      return matchingVariants.length > 0 && !matchingVariants.some(v => v.available);
    })();

    if (shouldHide) {
      hideButton.classList.add('d-none');
      if (currentVariant['option' + hidePos] === rule.hide_value) {
        const fallback = hideOptionWrapper.querySelector(
          `button[data-option-value]:not([data-option-value="${rule.hide_value}"]):not(.d-none)`
        );
        if (fallback) setTimeout(() => fallback.click());
      }
    } else {
      hideButton.classList.remove('d-none');
    }
  });
};

document.addEventListener("product:variant-change", function (evt) {
  if (evt.detail && evt.detail.variant) {
    hideUnavailableVariantOptions(String(evt.detail.variant.id));
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const variantsWrapper = document.querySelector('[data-product-variants][data-current-variant-id]');
  if (variantsWrapper) {
    hideUnavailableVariantOptions(String(variantsWrapper.getAttribute('data-current-variant-id')));
  }
});